import Api from "./api";

/**
 * ログイン、ログイン状態の検証をするクラス
 */
class Account {
  /**
   * ログインする
   */
  signIn(store, email, password) {
    return Api.call("/login", {
      email: email,
      password: password,
    }).then((result) => {
      // トークンを保存する
      store.commit("setToken", result.token);
      store.commit("setRefreshToken", result.refresh_token);
      return result;
    });
  }

  /**
   * ログアウトする
   */
  signOut(store, router) {
    // トークン、アカウント情報を初期化する
    store.commit("setToken", "");
    store.commit("setRefreshToken", "");
    store.commit("waitingInit");
    store.commit("setUserDisplayName", "");
    store.commit("setFlagSystemAdmin", false);
    store.commit("tosAgreed", "");
    store.commit("setUserGroupIds", []);
    store.commit("setUserId", "");
    store.commit("setPrefInformationNotice", false);
    store.commit("setInformationNotice", false);
    store.commit("setInformationEditable", false);
    store.commit("setCsvPermission", false);
    store.commit("setFlagProducer", false);
    store.commit("setSeaArea", 0);
    store.commit("setDeviceId", "3362,3362,3362");
    store.commit("setLocationId",  "0,0,0");

    if (router) {
      // 画面を遷移する
      router.push("/login");
    }
  }

  /**
   * ユーザー情報を反映する
   */
  applyUserInfo(store, users) {
    if (users && users.users && users.users.length >= 1) {
      // ユーザー情報、利用規約、システム管理者フラグのバージョンを参照する
      const { uid, display_name, tos_version, flag_system_admin, permissions, hiroshima_info_notice, information_notice, flag_information_admin, csv_permission, flag_producer, sea_area, device_id, location_id } = users.users[0];
      // ユーザーの表示名を更新する
      store.commit("setUserDisplayName", display_name || "-");
      // 利用規約の状態を共通ストアの状態に反映する
      store.commit("tosAgreed", tos_version || "");
      // システム管理者フラグの状態を共通ストアの状態に反映する
      store.commit("setFlagSystemAdmin", flag_system_admin || false);
      // ユーザーIDを共通ストアに反映する
      store.commit("setUserId", uid);
      // 所属グループIDを共通ストアに反映する
      store.commit(
        "setUserGroupIds",
        permissions
          .filter((permission) => permission.type == "join")
          .map((permission) => permission.owner.group_id)
      );
      // 所属グループパーミッションを共通ストアに反映する
      store.commit(
        "setUserJoinPermissions",
        permissions
          .filter((permission) => permission.type == "join")
          .map((permission) => permission)
      );
      store.commit("setPrefInformationNotice", hiroshima_info_notice || false);
      store.commit("setInformationNotice", information_notice || false);
      store.commit("setInformationEditable", flag_information_admin || false);
      // CSV出力権限フラグを共通ストアに反映する
      store.commit("setCsvPermission", csv_permission || false);
      // 生産者フラグを共通ストアに反映する
      store.commit("setFlagProducer", flag_producer || false);
      // 採取海域区分を共通ストアに反映する
      store.commit("setSeaArea", sea_area || 0);
      // うみログデバイスIDを共通ストアに反映する
      store.commit("setDeviceId", device_id || "3362,3362,3362");
      // うみログロケーションIDを共通ストアに反映する
      store.commit("setLocationId", location_id || "0,0,0");
    }
  }

  /**
   * ログイン状態を取得する
   * @returns ログイン中であればTrue
   */
  isSignIn(store) {
    return store.getters.token != "";
  }
}

export default new Account();
